import React, { Component, useRef } from "react";
import defaultUser from "../../assets/default-user.png";
import profile from "../../assets/profile.png";
import edit from "../../assets/edit.png";
import sun from "../../assets/sun.png";
import placeHolder from "../../assets/placeholders.png";
import { http, baseURL } from "../../misc/http";
import Select from "react-select";

const inputFile = React.createRef();
export default class MyAccount extends Component {
  state = {
    user: {},
    profiles: {},
    province: [],
    regency: [],
    picture: "",
  };

  openDialog = () => {
    inputFile.current.click();
  };

  getUserData = async () => {
    let user = JSON.parse(localStorage.getItem("kominfo-psre"));
    if (user !== null) {
      let params = {
        method: "GET",
        path: "profiles/" + user.email,
        token: user.token,
        showMessage: false,
      };
      let { data } = await http(params);
      if (data.status === true && data.code === 200) {
        this.setState({
          profiles: data.data,
          user: user,
          picturePath: data.data.picture ? baseURL + data.data.picture : "",
        });
      } else {
        this.setState({ user: user, profiles: {} });
      }
    }
  };

  componentDidMount = async () => {
    await this.getUserData();
    await this.getArea("settings/area/province", "province");
    await this.getArea(
      "settings/area/regency/" + this.state.profiles.province,
      "regency"
    );
  };

  getArea = async (path, stateName) => {
    let params = {
      method: "GET",
      path: path,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let dataArea = this.state[stateName];
      dataArea = data.data;
      this.setState({ [stateName]: dataArea });
    }
  };

  handleUploadFile = async () => {
    let formData = new FormData();
    formData.append("picture", this.state.picture);
    let params = {
      method: "POST",
      path: "profiles/uploadPicture/" + this.state.user.email,
      data: formData,
      content_type: "form-data",
      showMessage: false,
    };
    let { data } = await http(params);
    data.message ? alert(data.message) : alert("Update foto gagal");
  };

  handleOnChange = async ({ target: { name, value, files } }) => {
    console.log("checking", value);
    if (name === "province") {
      this.getArea("settings/area/regency/" + value, "regency");
    }
    if (name === "picture") {
      await this.setState({
        picturePath: URL.createObjectURL(files[0]),
        picture: files[0],
      });
      await this.handleUploadFile();
    } else {
      let { profiles } = this.state;
      profiles[name] = value;
      this.setState({ profiles });
    }
  };

  handleSubmit = async () => {
    let params = {
      method: "PUT",
      path: "profiles/" + this.state.user.email,
      showMessage: false,
      data: this.state.profiles,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      let { profiles } = this.state;
      profiles = data.data;
      this.setState({ profiles });
    }
    data.message ? alert(data.message) : alert("Data gagal disimpan");
  };

  render() {
    return (
      <section className="akun-saya">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div
                className="photo-profile"
                style={{ position: "relative", width: "150px" }}
              >
                <img
                  src={
                    this.state.picturePath !== ""
                      ? this.state.picturePath
                      : defaultUser
                  }
                  className="rounded-circle"
                  width="100%"
                  height="150"
                  style={{ objectFit: "cover" }}
                />
                <input
                  ref={inputFile}
                  type="file"
                  style={{ display: "none" }}
                  name="picture"
                  onChange={(e) => this.handleOnChange(e)}
                  accept="image/*"
                />
                <button
                  onClick={() => this.openDialog()}
                  href=""
                  className="edit-photo"
                  style={{ color: "white" }}
                  data-toggle="modal"
                  data-target="#edit-photo"
                >
                  <i className="fas fa-pen"></i>
                </button>
              </div>
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 col-12">
              <div className="auth" action="">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img
                            src={profile}
                            alt="profile"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Nama Anda"
                        name="name"
                        onChange={(e) => this.handleOnChange(e)}
                        value={this.state.profiles.name}
                        style={{ height: '5rem'}}
                      />
                    </div>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img
                            src={edit}
                            alt="profile"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                      <input
                        disabled={true}
                        className="form-control"
                        type="text"
                        placeholder="Alamat Email Anda"
                        name="email"
                        value={this.state.profiles.email}
                        style={{ height: '5rem'}}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img
                            src={placeHolder}
                            alt="profile"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                      <div style={{ width: "calc(100% - 5rem)" }}>
                        <Select
                          defaultValue={this.state.profiles.province}
                          options={this.state.province.map((e) => ({
                            value: e,
                            label: e,
                          }))}
                          onChange={(e) => {
                            this.handleOnChange({
                              target: { name: "province", value: e.value },
                            });
                          }}
                        />
                      </div>
                      {/* <select
                        className="select-primary form-control"
                        id=""
                        style={{
                          backgroundColor: "#F5F5F5",
                          padding: "15px 25px",
                          height: "4rem",
                        }}
                        defaultValue={this.state.profiles.province}
                        name="province"
                        onChange={(e) => {
                          console.log('checking change ', e)
                          this.handleOnChange(e)
                        }}
                      >
                        {this.state.province.length
                          ? this.state.province.map((e) => (
                              <option
                                selected={
                                  e === this.state.profiles.province
                                    ? true
                                    : false
                                }
                                value={e}
                              >
                                {e}
                              </option>
                            ))
                          : null}
                      </select> */}
                    </div>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img
                            src={placeHolder}
                            alt="profile"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                      <div style={{ width: "calc(100% - 5rem)" }}>
                        <Select
                          defaultValue={this.state.profiles.regency}
                          options={this.state.regency.map((e) => ({
                            value: e,
                            label: e,
                          }))}
                          onChange={(e) => {
                            this.handleOnChange({
                              target: { name: "regency", value: e.value },
                            });
                          }}
                        />
                      </div>
                      {/* <select
                        disabled={
                          this.state.profiles.province === "" ? true : false
                        }
                        className="select-primary form-control"
                        id=""
                        style={{
                          backgroundColor: "#F5F5F5",
                          padding: "15px 25px",
                          height: "4rem",
                        }}
                        value={this.state.profiles.regency}
                        name="regency"
                        onChange={(e) => this.handleOnChange(e)}
                      >
                        {this.state.regency.length
                          ? this.state.regency.map((e) => (
                              <option
                                selected={
                                  e === this.state.profiles.regency
                                    ? true
                                    : false
                                }
                                value={e}
                              >
                                {e}
                              </option>
                            ))
                          : null}
                      </select> */}
                    </div>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img
                            src={placeHolder}
                            alt="sun"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </div>
                      <textarea
                        className="form-control"
                        rows={5}
                        placeholder="Alamat Lengkap"
                        name="address"
                        value={this.state.profiles.address}
                        onChange={(e) => this.handleOnChange(e)}
                      />
                    </div>
                    <div
                      className="d-flex"
                      style={{ justifyContent: "flex-end" }}
                    >
                      <button
                        className="btn btn-blue mt-4"
                        type="submit"
                        style={{
                          padding: "10px 25px !important",
                          background: "#0085C7",
                        }}
                        onClick={() => this.handleSubmit()}
                      >
                        Simpan Informasi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
